import type { z } from 'zod';
import { ApiClientError } from './api';

export type FieldErrors = Record<string, string>;

/** Erreurs zod → message par chemin de champ (premier message conservé). */
export function zodFieldErrors(error: z.ZodError): FieldErrors {
  const fields: FieldErrors = {};
  for (const issue of error.issues) {
    const key = issue.path.map(String).join('.') || '_';
    fields[key] ??= issue.message;
  }
  return fields;
}

/** Erreurs de validation renvoyées par l'API (même format de chemins). */
export function apiFieldErrors(error: unknown): FieldErrors {
  return error instanceof ApiClientError && error.fields ? error.fields : {};
}
